import qs from "qs";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ServiceContext } from "../../../contexts/service";
import { useUnidades } from "../../../hooks/useScriptRef";
import { Api } from "../../../providers";
import { limitString } from "../../../utils/string";
import { SearchField } from "./components/searchField";
import styles from "./styles.module.scss";

const Search = () => {
    const {
        setOccurrences,
        setLoading,
        setTotalPages,
        setTotalElements,
        setParamsFilter,
    } = useContext(ServiceContext);
    const unidadesServer = useUnidades();
    const [busca, setBusca] = useState("");

    const [servicoID, setServicoID] = useState("");
    const [unidadeID, setUnidadeID] = useState("");
    const [status, setStatus] = useState("");
    const [requesterID, setRequesterID] = useState("");
    const [situacao, setSituacao] = useState([]);
    const [servicos, setServicos] = useState([]);
    const [requesterData, setRequesterData] = useState([]);

    useEffect(() => {
        let mounted = true;

        async function filterData() {
            try {
                await Promise.all([
                    Api.get("/servico/").then((res) => {
                        if (mounted) {
                            const result = res.data.filter(
                                (data) => data.flagAtivo,
                            );
                            setServicos(result);
                        }
                    }),

                    Api.get("/ocorrencia/status/").then((res) => {
                        if (mounted) {
                            setSituacao(res.data);
                        }
                    }),

                    Api.get(`/restricao/solicitante`).then((res) => {
                        if (mounted && res.status === 200) {
                            setRequesterData(res.data);
                        }
                    }),
                ]);
            } catch (_) {
                toast.error("Ops! Aconteceu algum problema com os filtros!", {
                    toastId: "msg",
                });
            }
        }

        filterData();
        return () => {
            mounted = false;
        };
    }, []);

    const handleSumbit = (event) => {
        setLoading(true);
        event.preventDefault();

        let params = {};
        if (busca != "") params.fields = busca;
        if (status != "" && status != "0") params.status = status;
        if (unidadeID != "0") params.unidadeId = unidadeID;
        if (servicoID != "" && servicoID != "0") params.servicoId = servicoID;
        if (requesterID != "0") params.solicitante = requesterID;

        Api.get(`/ocorrencia/pagination/0/10?`, {
            params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        })
            .then((res) => {
                // Provider
                setOccurrences(res.data.content);
                setTotalPages(res.data.totalPages);
                setTotalElements(res.data.totalElements);
                setParamsFilter(params);
                setLoading(false);
            })
            .catch((_) => {
                toast.error("Ops! Aconteceu algum problema!", {
                    toastId: "msg",
                });
                setLoading(false);
            });
        return true;
    };

    const searchText = (text) => {
        if (text.length > 0 && text.trim()) {
            setBusca(text);
        } else {
            setBusca("");
        }
    };

    const getStatus = (status) => {
        switch (status) {
            case "Finalizada":
                return status;
            case "Análise":
                return "Em análise";
            case "Enviada":
                return "Aberta";
            default:
                return status;
        }
    };

    return (
        <div className="conteudo-tabela">
            <form>
                <div>
                    <div>
                        <SearchField
                            placeholder="Número, nome do profissional, nome do cliente..."
                            onClick={handleSumbit}
                            onChange={(e) => searchText(e.target.value)}
                            search={busca}
                        />
                    </div>

                    <div className={styles.containerFilds}>
                        <div className={styles.subContainerFilds}>
                            <span>Filtrar resultados</span>
                            <div className={styles.containerSelect}>
                                <div className={styles.fieldSelect}>
                                    <select
                                        className="form-select"
                                        value={status}
                                        onChange={(e) =>
                                            setStatus(e.target.value)
                                        }
                                    >
                                        <option value="" key="0" disabled>
                                            Status
                                        </option>
                                        <option value="0" key="999">
                                            Todos
                                        </option>
                                        {situacao.map((data, key) => {
                                            return (
                                                <option
                                                    value={data}
                                                    key={key + 1}
                                                >
                                                    {limitString(
                                                        getStatus(data),
                                                    )}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className={styles.fieldSelect}>
                                    <select
                                        className="form-select"
                                        value={servicoID}
                                        onChange={(e) =>
                                            setServicoID(e.target.value)
                                        }
                                    >
                                        <option value="" key="0" disabled>
                                            Serviço
                                        </option>
                                        <option value="0" key="999">
                                            Todos
                                        </option>
                                        {servicos.map(({ id, nome }, key) => {
                                            return (
                                                <option
                                                    value={id}
                                                    key={key + 1}
                                                >
                                                    {limitString(nome)}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className={styles.fieldSelect}>
                                    <select
                                        className="form-select"
                                        value={unidadeID}
                                        onChange={(e) =>
                                            setUnidadeID(e.target.value)
                                        }
                                    >
                                        <option value="" key="0" disabled>
                                            Unidade
                                        </option>
                                        <option value="0" key="999">
                                            Todos
                                        </option>
                                        {unidadesServer.map(({ id, nome }) => {
                                            return (
                                                <option value={id} key={id}>
                                                    {nome}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className={styles.fieldSelect}>
                                    <select
                                        className="form-select"
                                        value={requesterID}
                                        onChange={(e) =>
                                            setRequesterID(e.target.value)
                                        }
                                    >
                                        <option value="" key="0" disabled>
                                            Solicitante
                                        </option>
                                        <option value="0" key="999">
                                            Todos
                                        </option>
                                        {requesterData.length > 0 &&
                                            requesterData.map((data) => (
                                                <option key={data} value={data}>
                                                    {data}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Search;
